<div class="container">
  <h3>Unauthorized</h3>
  <div *ngIf="error$ | async as error; else default">
    <p *ngIf="error == 'noAccessibleAirCarriers'">
      You do not have any accessible Air Carriers, please reach out to your supervisor for access.
    </p>
    <p *ngIf="error == 'airCarrierNotAccessible'">
      You do not have access to this Air Carrier, please reach out to your supervisor for access.
    </p>
  </div>
  <ng-template #default>
    <p>The current user does not have access to the requested resource.</p>
  </ng-template>
</div>
